export const PRIVATEKEY =
  '8a4af424bd714be5b2baacbe3cf5bbbe0131effeb92e99356ef1662884558f28';

export const LOGINKEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbk5hbWUiOiJleUpoYkdjaU9pSklVekkxTmlJc0luUjVjQ0k2SWtwWFZDSjkuZXlKc2IyZHBiazVoYldVaU9pSmhJaXdpWlhod0lqb3hOakkzTURrME1qZzJMQ0oxYzJWeVNXUWlPaUpoSW4wLkczSkpyb2t6Y0c0ejlZOU1KM0NmaFRGcjFKa3NvMjFaeHc3VzRCRVJvZWsiLCJleHAiOjE2MjcxMTA3MTgsInVzZXJJZCI6ImEifQ.68cMg14UgJ-A_eFxuVo8YA8H-PeDzM8d4jngPcpr2K8';